import styled from 'styled-components/macro';

type InfoCardWrapStyledT = {
  fullWidth?: boolean;
  compact?: boolean;
};

export const InfoCardWrapStyled = styled.div<InfoCardWrapStyledT>`
  position: relative;
  border-radius: 12px;
  border: 2px solid transparent;
  background: ${({ theme }): string => theme.colors.surface};
  padding: ${({ compact }): string => (compact ? '4px 14px' : '12px 14px')};
  width: ${({ fullWidth }): string => (fullWidth !== false ? '100%' : 'fit-content')};
  box-sizing: border-box;
  outline: none;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  &:focus-within {
    border-color: ${({ theme }): string => theme.colors.focusRing};
    box-shadow: 0 0 4px 2px ${({ theme }): string => theme.colors.focusRing};
  }
`;
